import React from "react";
import { Box, Container, useMediaQuery } from "@mui/material";
import theme from "./Theme";
import { useTranslation } from "react-i18next";

interface BackgroundImageProps {
  imageUrl?: string;
  altImage?: string;
  isPricingPage?: boolean;
  children: React.ReactNode;
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({
  imageUrl,
  altImage,
  isPricingPage,
  children,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container
      sx={{
        position: "relative",
        height: isPricingPage && isMobile ? "74vh" : "100vh",
        maxWidth: "none !important",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          "::before": {
            content: '""',
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.55)",
            zIndex: 1,
          },
        }}
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt={altImage ? altImage : "Image"}
            loading="eager"
            width="2048"
            height="1365"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: isPricingPage && isMobile ? "none" : "cover",
              objectPosition: isPricingPage && isMobile ? "right" : "center",
              zIndex: 0,
            }}
          />
        )}
      </Box>
      <Box
        sx={{ position: "relative", zIndex: 2, px: isMobile ? "20px" : "73px" }}
      >
        {children}
      </Box>
    </Container>
  );
};

export default BackgroundImage;
